import React from 'react';

// Import components
import PacketMainModal from '../common/offer/main/PacketMainModal';
import PacketLink from '../common/offer/main/PacketLink';

// Import data
import { getPersistedData } from '../data';

const generateRandomLiKey = () => (Math.random() + 1).toString(36).substring(8);

// Replace anchor tag with modal
export const replaceAnchorWithModal = (packetName, space) => (node) => {
	if (node.type === 'tag' && node.name === 'li') {
		node.attribs = { ...node.attribs, key: generateRandomLiKey() };
	}
	if (node.type === 'tag' && node.name === 'a') {
		if (node.attribs?.target === '_blank') {
			return (
				<PacketLink
					title={node?.children?.[0]?.data ?? 'Link'}
					link={node.attribs?.title}
				/>
			);
		}
		return (
			<PacketMainModal
				key={generateRandomLiKey()}
				href={node.attribs.href}
				packetName={packetName}
				space={space}
			/>
		);
	}
};

export const removeListFromContent = (node) => {
	return node.type === 'tag' && node.name === 'ul' && <></>;
};

export const randomNumber = (min, max) => {
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

const combineQueryParams = (key) => {
	const currentSearch = window.location.search;
	const hash = getPersistedData();

	if (!currentSearch) return `?${key}=${hash}`;
	if (currentSearch.includes(`${key}=`)) {
		return currentSearch;
	}
	if (currentSearch && hash) return `${currentSearch}&${key}=${hash}`;
	return '';
};

export const generateRestoreLink = (key = 'pakiety') => {
	const path = `${window.location.origin}${window.location.pathname}`;
	return `${path}${combineQueryParams(key)}`;
};
